var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-colour",class:{ selected: _vm.selected, 'selected-invert': _vm.colour === 'rgb(0,0,0)' },style:({ backgroundColor: _vm.colour })})}
var staticRenderFns = []

export { render, staticRenderFns }